<template>
	<div class="form-group" :class="[componentClass, activeClass]">
		<validation-provider v-slot="{ errors, classes }" :rules="rules" :vid="vid">
			<input
				:id="name"
				:type="type"
				:name="name"
				:class="classes"
				class="form-control"
				autocomplete="off"
				v-bind="$attrs"
				:value="value"
				@input="$emit('input', $event.target.value)"
			/>
			<i v-if="showPasswordToggle" class="toggle-password fa" :class="toggleIcon" @click="togglePassword"></i>
			<label v-if="showLabel" :for="name">
				{{ $t(label) }}{{ requiredMark }} <span v-if="showErrors" class="form-error">{{ errors[0] }}</span>
			</label>
		</validation-provider>
	</div>
</template>

<script>
import Helpers from '@/mixins/Helpers'

export default {
	name: 'FormInput',
	mixins: [Helpers],
	inheritAttrs: false,
	props: {
		componentClass: {
			type: String,
			default: '',
		},
		forceRequiredMark: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			required: true,
		},
		rules: {
			type: [String, Object],
			default: '',
		},
		showErrors: {
			type: Boolean,
			default: false,
		},
		componentType: {
			type: String,
			default: 'text',
			validator: function (value) {
				return ['text', 'hidden', 'number', 'password'].indexOf(value) !== -1
			},
		},
		value: {
			type: [String, Number],
			default: '',
		},
		vid: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			toggleIcon: 'fa-eye',
			type: this.componentType,
		}
	},
	computed: {
		activeClass() {
			return this.value !== '' && this.value !== null ? 'field-active' : ''
		},
		showPasswordToggle() {
			return this.componentType === 'password'
		},
	},
	methods: {
		togglePassword() {
			if (this.type === 'password') {
				this.type = 'text'
				this.toggleIcon = 'fa-eye-slash'
			} else {
				this.type = 'password'
				this.toggleIcon = 'fa-eye'
			}
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/FormInput.vue